import { render, staticRenderFns } from "./modalUniversal.vue?vue&type=template&id=70899e90&scoped=true&"
import script from "./modalUniversal.vue?vue&type=script&lang=js&"
export * from "./modalUniversal.vue?vue&type=script&lang=js&"
import style0 from "./modalUniversal.vue?vue&type=style&index=0&id=70899e90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70899e90",
  null
  
)

export default component.exports